import { Box, Typography, TextField, Grid, InputAdornment, InputLabel } from '@mui/material';
import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import PrimaryButton from '../../components/PrimaryButton';
import axios from 'axios';
// import { toast } from 'react-toastify';
import { API } from '../../utils/Api';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import gsap from 'gsap';
import Images from '../../utils/Images';
import toast, { Toaster } from 'react-hot-toast';

function AccountDetails() {
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [name, setName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [referral, setReferral] = useState('');
  const [errors, setErrors] = useState({});
  const location = useLocation();
  const navigate = useNavigate();
  const mobile = location.state?.mobile || '';
  const referralId = localStorage.getItem('referralId');
  const [btnDisabledAccount, setBtnDisabledAccount] = useState(false);

  useEffect(() => {
    gsap.fromTo('.mainBox', { x: '100%' }, { x: '0%', duration: 1, ease: 'power3.out' });
  }, []);

  const schema = Yup.object().shape({
    name: Yup.string().required('Name is required').matches(/^[A-Za-z][A-Za-z'-]* ?([A-Za-z'-]+ ?)*$/, 'Name must contain only letters, spaces, hyphens, and apostrophes').min(2, 'Name must be at least 2 characters').trim(),
    lastName: Yup.string().optional().matches(/^[A-Za-z][A-Za-z'-]* ?([A-Za-z'-]+ ?)*$/, 'Last Name must contain only letters, spaces, hyphens, and apostrophes').min(2, 'Last Name must be at least 2 characters').trim(),
    // name: Yup.string().required('Name is required').matches(/^[A-Za-z]+$/, 'Name must contain only letters').min(2, 'Name must be at least 2 characters').trim(),
    email: Yup.string().email('Invalid email address').required('Email is required').trim(),
    referral: Yup.string()
      .nullable()
      .notRequired()
      .test(
        'valid-mobile',
        'Must be a 10 digit number starting with 6, 7, 8, or 9',
        value => !value || /^[6789][0-9]{9}$/.test(value)
      )
  });

  const validateField = async (field, value) => {
    try {
      await schema.validateAt(field, { [field]: value });
      setErrors({ ...errors, [field]: '' });
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        setErrors({ ...errors, [field]: error.message });
      }
    }
  };

  const handleInputChange = (field, value) => {
    if (field === 'name') {
      setName(value);
      validateField('name', value);
    } else if (field === 'email') {
      setEmail(value);
      validateField('email', value);
    } else if (field === 'lastName') {
      setLastName(value);
      validateField('lastName', value);
    } else if (field === 'referral') {
      setReferral(value);
      validateField('referral', value);
    }
  };

  const handleButtonClick = async () => {
    const isValid = await schema.isValid({
      name,
      lastName,
      email,
      referral
    });
    setBtnDisabledAccount(true);
    if (isValid) {
      const requestData = {
        "name": name,
        "lastName": lastName,
        "signupType": "REGULAR",
        "mobile": mobile,
      };
      if (email) {
        requestData.email = email;
      }
      if (referralId) {
        requestData.referringUser = referralId;
      }
      if (referral) {
        requestData.referringUserMobile = referral;
      }
      try {
        const response = await axios.post(`${API.BASE_URL_2}auth/user/create-account`, requestData);
        if (response?.data?.status === true) {
          // console.log('Account created successfully:', response?.data?.data);
          toast.success('Account created successfully!', {
            autoClose: 3000,
          });
          localStorage.setItem('token', response?.data?.data?.token);
          localStorage.setItem('userDataLogin', JSON.stringify(response?.data?.data?.createdUser));
          // if (response?.data?.data?.user?.profileImage !== null) {
          //   localStorage.setItem('userProfileImage', response?.data?.data?.user?.profileImage);
          // }
          localStorage.setItem('userProfileImage', Images.navProfile);
          localStorage.setItem('userNameHeader', response?.data?.data?.createdUser?.name);
          navigate('/welcomeScreen', { state: { couponPercentage: response?.data?.data?.userCouponData?.coupon?.discountPercent, couponCode: response?.data?.data?.userCouponData?.coupon?.couponCode } });
          localStorage.setItem('couponPercentage', response?.data?.data?.userCouponData?.coupon?.discountPercent);
          localStorage.setItem('couponDiscountAmount', response?.data?.data?.userCouponData?.coupon?.discountAmount);
          localStorage.setItem('couponCode', response?.data?.data?.userCouponData?.coupon?.couponCode);
        }
      } catch (error) {
        // console.error('Error:', error?.response?.data?.data?.message || error?.response?.data?.error);
        const errorMessage = error?.response?.data?.data?.message || error?.response?.data?.error || "Try again after sometime.";
        toast.error(errorMessage);
        setBtnDisabledAccount(false);
      } finally {
        setBtnDisabledAccount(false);
      }
    } else {
      setErrors({ name: 'Name is required', email: 'Email is required' });
      setBtnDisabledAccount(false);
    }
  };

  return (
    <>
      <Box className="accountDetails" sx={{ textAlign: 'left', padding: '0px', margin: '0px' }}>
        <Grid className="mainBox" item md={3} sx={{ padding: '10px', margin: '0px' }}>
          <Typography sx={{ fontWeight: '800', fontSize: '20px', margin: '1px 0 12px 0', lineHeight: '1.2' }}>
            Help us get to know you
          </Typography>
          <Box sx={{ textAlign: 'left' }}>
            <TextField
              fullWidth
              id="name"
              sx={{
                border: '3px solid #1E9CED',
                borderRadius: '8px',
                backgroundColor: '#fff',
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: '#1DA1F2',
                  },
                  '&:hover fieldset': {
                    borderColor: 'cornflowerblue',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#1DA1F2',
                  },
                },
              }}
              placeholder="Name"
              variant="outlined"
              value={name}
              onChange={(e) => handleInputChange('name', e.target.value)}
              onBlur={() => validateField('name', name)}
              InputLabelProps={{
                shrink: true,
              }}
              error={!!errors.name}
            />
            {errors.name && (
              <Typography className="errorText" color="error">
                {errors.name}
              </Typography>
            )}
            <TextField
              fullWidth
              id="lastName"
              sx={{
                border: '3px solid #1E9CED',
                borderRadius: '8px',
                backgroundColor: '#fff',
                marginTop: '20px',
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: '#1DA1F2',
                  },
                  '&:hover fieldset': {
                    borderColor: 'cornflowerblue',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#1DA1F2',
                  },
                },
              }}
              placeholder="Last Name (optional)"
              variant="outlined"
              value={lastName}
              onChange={(e) => handleInputChange('lastName', e.target.value)}
              onBlur={() => validateField('lastName', lastName)}
              InputLabelProps={{
                shrink: true,
              }}
              error={!!errors.lastName}
            />
            {errors.lastName && (
              <Typography className="errorText" color="error">
                {errors.lastName}
              </Typography>
            )}
            <TextField
              fullWidth
              id="email"
              sx={{
                border: '3px solid #1E9CED',
                marginTop: '20px',
                borderRadius: '8px',
                backgroundColor: '#fff',
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: '#1DA1F2',
                  },
                  '&:hover fieldset': {
                    borderColor: 'cornflowerblue',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#1DA1F2',
                  },
                },
              }}
              placeholder="Email"
              variant="outlined"
              value={email}
              onChange={(e) => handleInputChange('email', e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              error={!!errors.email}
            />
            {errors.email && (
              <Typography className="errorText" color="error">
                {errors.email}
              </Typography>
            )}
          </Box>
          <Typography sx={{ fontWeight: '800', fontSize: '20px', margin: '15px 0 2px 0', lineHeight: '1.2' }}>
            Referred by someone? (Optional)
          </Typography>
          <TextField
            fullWidth
            id="referral"
            sx={{
              border: '3px solid #1E9CED',
              marginTop: '10px',
              borderRadius: '8px',
              backgroundColor: '#fff',
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: '#1DA1F2',
                },
                '&:hover fieldset': {
                  borderColor: 'cornflowerblue',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#1DA1F2',
                },
              },
            }}
            placeholder="Enter their number"
            variant="outlined"
            value={referral}
            onChange={(e) => handleInputChange('referral', e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
            error={!!errors.referral}
          />
          {errors.referral && (
            <Typography className="errorText" color="error">
              {errors.referral}
            </Typography>
          )}
          <Grid container justifyContent={'center'} style={{ margin: '27px 0 27px 0' }}>
            <Grid item xs={12} sm={12} md={12}>
              <PrimaryButton
                title={'Continue'}
                onClick={handleButtonClick}
                spinner={true}
                style={{ borderRadius: '30px', fontSize: '18px' }}
                disabledTitle={'Please Wait'}
                disabled={btnDisabledAccount}
              />
            </Grid>
          </Grid>
          <Box className="progressBox">
            <img className='progressDots img-fluid' src={Images.secondScreenDots} alt='ProgressDots' />
          </Box>
        </Grid>
      </Box>
    </>
  );
}

export default AccountDetails;